/**
 * URL utilities for popup windows
 */

/**
 * Get popupId from current URL
 */
export const getPopupIdFromUrl = (): string | null => {
  const params = new URLSearchParams(window.location.hash.split('?')[1] || '');
  return params.get('popupId');
};

/**
 * Get all URL params for current popup
 */
export const getPopupParams = (): Record<string, string> => {
  const params = new URLSearchParams(window.location.hash.split('?')[1] || '');
  return Object.fromEntries(params.entries());
};

/**
 * Check if the current window is a popup
 */
export const isPopupWindow = (): boolean => {
  return window.opener !== null || window.location.hash.includes('/popup/');
};
